import React, { Component } from 'react'
import { relativizeURL, decode } from 'lib/Utils'
import { Link } from 'react-router'
import EntryDate from 'components/EntryDate'
import './index.scss'

class EntryListItem extends Component {
  render () {
    let item = this.props.item

    let featuredImage = false
    let featuredImageSrc = ''
    let featuredImageTitle = ''
    if (item._embedded['wp:featuredmedia'] && item._embedded['wp:featuredmedia'].length > 0) {
      featuredImage = item._embedded['wp:featuredmedia'][0]
      if (!(featuredImage.hasOwnProperty('data') && featuredImage.data.hasOwnProperty('status') && featuredImage.data.status !== 200)) {
        featuredImageSrc = featuredImage.media_details.sizes.medium.source_url
        featuredImageTitle = featuredImage.title.rendered
      } else {
        featuredImage = false
      }
    }

    return (
      <li className='entry-item'>
        <Link to={relativizeURL(item.link)}>
          {
            featuredImage !== false &&
            <div className='entry-item__image allow-hover'>
              <div>
                <img src={featuredImageSrc} alt={featuredImageTitle} />
              </div>
            </div>
          }
          <div className='entry-item__details'>
            <EntryDate date={item.date} />
            <h2>{decode(item.title.rendered)}</h2>
            <div className='entry-item__term'>{item._embedded['wp:term'][0][0].name}</div>
          </div>
        </Link>
      </li>
    )
  }
}

export default EntryListItem



// WEBPACK FOOTER //
// ./src/components/EntryListItem/index.js